(function ($) {
  'use strict';

  $.extend(true, $.trumbowyg, {
    plugins: {
      variableSelect: {
        init: function (trumbowyg) {
            if (!trumbowyg.o.variableList) return false;
            trumbowyg.o.plugins.variableSelect = trumbowyg.o.plugins.variableSelect || {};
            var btnDef = {
                dropdown: buildDropdown(trumbowyg),
                hasIcon: false,
                text: trumbowyg.o.variableSelectorTitle,
            };
            trumbowyg.addBtnDef('variableSelect', btnDef);
        }
      }
    }
  });
  function buildDropdown(trumbowyg) {
    var items;
    if (trumbowyg.o.variableList && trumbowyg.o.variableList.length) {
      items = trumbowyg.o.variableList.map((el) => ({ text: el, value: `{{${el}}}` }));
    }
  
    var dropdown = [];
  
    $.each(items, function (i, item) {

        var btn = 'var-' + i,
              btnDef = {
                  hasIcon: false,
                  text: item.text,
                  fn: function () {
                      trumbowyg.execCmd('insertHTML', item.value);

                      return true;
                  }
              };

          trumbowyg.addBtnDef(btn, btnDef);
          dropdown.push(btn);
    });
    return dropdown;
  }
})(jQuery);

